module.exports = window["LP"]["quiz"];